export interface ForecastTemplate{
    name : string;
    planbyid : number;
    selecteddisciplines : number[];
    assignedvalue : AutoForecastAssignedValue;
    overriddenvalues : TemplateOverrideValue[];
}

export interface AutoForecastAssignedValue{
    value: number;
    weekdays : number[];
    selecteddisciplinemodes : DisciplineMode[];
}

export interface DisciplineMode{
    disciplineid : number;
    modeid : number;
}

export interface TemplateOverrideValue{
    weekdayid : number;
    disciplinemode : DisciplineMode;
    value : number;
}

export interface AutoForecast{
    id : string | null
    name : string;
    planbyid : number;
    corpid : string;
    facilityid : string | null;
    selecteddisciplines : number[];
    assignedvalue : AutoForecastAssignedValue;
    overriddenvalues : TemplateOverrideValue[];
}


export interface AutoForecastReviewRequest{
    patientId : string;
    facilityId : string | undefined;
    disciplineIds : number[];
    startDate : string;
    durationInWeeks : number;
    weekdays : number[];
}

export interface ApplyAutoForecastTemplate{
    patientid : string;
    facilityid : string;
    patientfacilityid : number;
    planbyid : number;
    startDate : string;
    duration : number;
    assignedValue : AutoForecastAssignedValue;
    forecastOverridenValues : DisciplineModeWeekDayValue[]
}

export interface DisciplineModeWeekDayValue{
    weekdayid : number;
    disciplineid : number;
    modeid : number;
    value : number;
}

export interface AutoForecastReviewResponse{
    isReviewRequired : boolean;
    alertsByDiscipline : AlertsByDiscipline[];
}

export interface AlertsByDiscipline{
    disciplineId : number;
    existingDataOverlapAlert : ExistingDataOverlapAlert;
    durationAlert : DurationAlert; 
}

export interface ExistingDataOverlapAlert{
    lastForecastDate : string;
}

export interface DurationAlert {
    weeksToOverrideExistingData : number;
}

export enum ForecastTemplateMode{
    AddOrEdit = 1,
    Apply
}

export interface ForecastTemplateList {
    id : string;
    name : string;
    disciplines : number[];
    createdBy : string;
    createdDate : string;
    isHidden : boolean;
    isCorporationTemplate : boolean;
}


export interface HideOrUnhideForecastTemplate {
    facilityid : string;
    templateid : string;
    hideTemplate : boolean;
}